import {  GET_CHILD_ACTIVE_ONLY_ACTIF, GET_ALL_CLIENTS, DELETE_CLIENT } from "../Actions/StudentActions";

const initialState: any = {
  clients: [],
  activeClients: [],
};

/**
 * state.clients est la réponse paginée de all_clients ({ data, totalItems,
 * totalValidated, totalNotValidated, totalArchived, ... }) ou null : on retire
 * les lignes de ce mail de data et on ajuste les compteurs lus par la liste,
 * le tableau de bord et les cours, sans changer la forme du state.
 */
const removeClientByMail = (clients: any, mail: string) => {
  if (!clients || !Array.isArray(clients.data)) return clients;
  const target = String(mail ?? '').toLowerCase();
  const removed = clients.data.filter((row: any) => String(row?.mail ?? '').toLowerCase() === target);
  if (removed.length === 0) return clients;

  const isArchived = (row: any) => !!(row?.isArchive ?? row?.is_archive);
  const decrement = (value: unknown, count: number) =>
    typeof value === 'number' ? Math.max(value - count, 0) : value;
  // mêmes définitions que les totaux calculés par l'API
  const removedValidated = removed.filter((row: any) => row?.isValidated === true && !isArchived(row)).length;
  const removedNotValidated = removed.filter((row: any) => row?.isValidated === false).length;
  const removedArchived = removed.filter((row: any) => row?.isValidated === true && isArchived(row)).length;

  return {
    ...clients,
    data: clients.data.filter((row: any) => !removed.includes(row)),
    totalItems: decrement(clients.totalItems, removed.length),
    totalValidated: decrement(clients.totalValidated, removedValidated),
    totalNotValidated: decrement(clients.totalNotValidated, removedNotValidated),
    totalArchived: decrement(clients.totalArchived, removedArchived),
  };
};

// Reducer
export default function studentReducer(state = initialState, action: any): any {
  switch (action.type) {
    case GET_ALL_CLIENTS:
      return { ...state, clients: action.payload };
    case DELETE_CLIENT:
      return { ...state, clients: removeClientByMail(state.clients, action.payload) };
    case GET_CHILD_ACTIVE_ONLY_ACTIF:
      return { ...state, activeClients: action.payload };
    default:
      return state;
  }
}
